import {
    GET_ALL_SOLUTIONS
} from './constants';

const initialState = {
    allSolutions: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_SOLUTIONS: {
            return {
                ...state,
                allSolutions: action.payload,
            };
        }
        default:
            return state;
    }
};

